/**
 * Défini le token d'authentification
 * @type {string}
 */
export const USER_SET_TOKEN = 'setToken'

/**
 * Défini l'utilisateur connecté
 * @type {string}
 */
export const USER_SET_USER = 'setUser'

/**
 * Met à jour l'agence
 * @type {string}
 */
export const USER_SET_USER_AGENCY = 'setUserAgency'

/**
 * Ajoute le dernier login utilisé à la liste
 * @type {string}
 */
export const USER_ADD_PREV_LOGIN = 'addPrevLogin'

/**
 * Altère le profil
 * @type {string}
 */
export const USER_SET_ALTERATE_PROFILE = 'alterateProfile'

/**
 * Altère l'agence
 * @type {string}
 */
export const USER_SET_ALTERATED_AGENCY = 'alterateAgency'
